// extracted by mini-css-extract-plugin
export var btn = "rightSectionNewDesign-module--btn--9lNqR";
export var container = "rightSectionNewDesign-module--container--oBdro";
export var containerTooltip = "rightSectionNewDesign-module--containerTooltip--5Jh5O";
export var notBtn = "rightSectionNewDesign-module--notBtn--1+kz8";